import { LocalStorageAdapter } from '@/lib/adapters/local-storage';
import { Styles } from 'react-joyride';
import { PartialDeep } from 'type-fest';

export const adapter = new LocalStorageAdapter('tutorial');

export const JOYRIDE_STYLES: PartialDeep<Styles> = {
  options: {
    zIndex: 10000,
  },

  tooltip: {
    width: '568px',
    maxWidth: '100vw',
    padding: 0,
    paddingTop: 24,
  },

  tooltipFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: '1px solid #DFDFDF',
    padding: 24,
    gap: 10,
    marginTop: 48,
  },

  tooltipFooterSpacer: {
    flex: 0,
  },

  tooltipContent: {
    padding: 0,
  },

  buttonClose: {
    color: '#111111',
    width: 16,
    height: 16,
    padding: 32,
  },

  buttonNext: {
    padding: '18px 32px',
    backgroundColor: '#111111',
    color: '#FFFFFF',
    borderRadius: 999,
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 700,
  },

  beacon: {
    display: 'none',
  },

  buttonSkip: {
    padding: '18px 32px',
    backgroundColor: 'transparent',
    color: 'black',
    borderRadius: 999,
    border: '1px solid black',
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 700,
  },
};
